import {MEMBERSHIP_TYPE} from 'od-modules/utils/membership_constants';

const FREE_TRIAL_KEYS = [
    'memberHeaderPrice',
    'lightboxHeader',
    'lightboxSubHeader',
    'headerFreeAccount',
    'basicButtonNew',
    'titleNew',
    'titleNew2',
    'titleNew3',
    'titleNew4',
    'lightboxTextsHeader',
    'lightboxTextsDescription',
    'lightboxTextsPrimary',
    'lightboxTextsSecondary',
    'prodAddedStepFourText',
];

const SIX_MONTHS_KEYS = [
    'memberHeaderPrice',
    'lightboxHeader',
    'headerFreeAccount',
];

function getKeyMembershipType(key, membershipType) {
    switch (true) {
        case (membershipType === MEMBERSHIP_TYPE.FREE_TRIAL):
            return FREE_TRIAL_KEYS.indexOf(key) >= 0 ? key + membershipType : key;
        case (membershipType === MEMBERSHIP_TYPE.SIX_MONTHS):
            return SIX_MONTHS_KEYS.indexOf(key) >= 0 ? key + membershipType : key;
        default:
            return key;
    }
}

export {getKeyMembershipType};
